import dayjs from 'dayjs';
const storeProjectId: string | null = localStorage.getItem('projectId') || '';
export interface DropdownValue {
  id: number;
  value: string;
}
export interface ProjectPaymentScheduleEntry {
  id: string;
  projectId: string;
  childId: string;
  orderId: number;
  lst_PaymentType: DropdownValue;
  paymentAmt: number;
  newAmount: number;
  changeBy: number | null;
  lst_CreatedBy: DropdownValue;
  lst_Modified: DropdownValue;
  createdDT: string;
  modifiedDT: string;
}
export interface SaleInitialValues {
  id: string;
  projectId: string;
  lst_SaleRepresentative: DropdownValue;
  lst_FollowUpSale: DropdownValue;
  lst_CreatedBy: DropdownValue;
  lst_ModifiedBy: DropdownValue;
  createdDT: string;
  modifiedDT: string;
  saleDate: string;
  salePrice: number;
  totalAdendum: number;
  totalContractAmt: number;
  totalPaymentAmt: number;
  totalPaymentDistribution: number;
  currentAdendumAmt: number;
  projectPaymentSchedule: ProjectPaymentScheduleEntry[];
}

export const initialValuesSale = {
  id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  projectId: storeProjectId,
  lst_SaleRepresentative: {
    id: 0,
    value: ""
  },
  lst_FollowUpSale: {
    id: 0,
    value: ""
  },
  lst_CreatedBy: {
    id: 0,
    value: ""
  },
  lst_ModifiedBy: {
    id: 0,
    value: ""
  },
  createdDT: "2024-11-21T07:44:25.100Z",
  modifiedDT: "2024-11-21T07:44:25.100Z",
  saleDate: dayjs().format('YYYY-MM-DD'),
  salePrice: 0,
  totalAdendum: 0,
  totalContractAmt: 0,
  totalPaymentAmt: 0,
  totalPaymentDistribution: 0,
  currentAdendumAmt: 0,
  projectPaymentSchedule: [
    {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      childId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      orderId: 0,
      lst_PaymentType: {
        id: 0,
        value: ""
      },
      paymentAmt: 0,
      newAmount: 0,
      changeBy: null,
      lst_CreatedBy: {
        id: 0,
        value: ""
      },
      lst_Modified: {
        id: 0,
        value: ""
      },
      createdDT: "2024-11-21T07:44:25.100Z",
      modifiedDT: "2024-11-21T07:44:25.100Z"
    }
  ]
}

export const initialValuesPromoteToSw = {
  projectId: storeProjectId,
  promoteDetails: {
    projectNumber: "",
    superintendent: {
      id: 0,
      value: ""
    },
    leadSaleDate: "",
    leadSaleAcceptedDate: "",
    jobCompleteDate: "",
    warrantyEndDate: ""
  },
  propertyAddress: {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    addressLine1: "",
    addressLine2: "",
    zipCode: "",
    stateId: 0,
    stateName: "",
    cityId: 0,
    cityName: "",
    chooseCityId: 0,
    chooseCityName: "",
    addressTypeId: 0,
    addressTypeName: ""
  },
  comments: ""
}

export interface PaymentSchedule {
  id: string;
  childId: string | null;
  projectId: string;
  orderId: number;
  lst_PaymentType: {
    id: number;
    value: string;
  };
  addendaNbr: string;
  paymentAmt: number;
  newAmount: number;
  changeBy: number;
  lst_CreatedBy: {
    id: number;
    value: string;
  };
  lst_Modified: {
    id: number;
    value: string;
  };
  createdDT: string;
  modifiedDT: string;
}

export const initialValuesPaymentSchedule: PaymentSchedule[] = [];
